export enum ParticipantEnrollmentSteps {
	PARTICIPANT_RECORD = 'PARTICIPANT_RECORD',
	WHO_WILL_ENROLL = 'WHO_WILL_ENROLL',
	BENEFIT_ENROLLMENT = 'BENEFIT_ENROLLMENT',
}

export interface ParticipantEnrollmentAppState {
	currentStep: ParticipantEnrollmentSteps,
	isEligible: boolean,
}

export enum ParticipantEnrollmentAppActions {
	SET_PARTICIPANT_ENROLLMENT_CURRENT_STEP = 'SET_PARTICIPANT_ENROLLMENT_CURRENT_STEP',
	SET_PARTICIPANT_ENROLLMENT_ELIGIBILITY = 'SET_PARTICIPANT_ENROLLMENT_ELIGIBILITY',
}